import React from 'react';
import { FieldWrapper, FieldLabel, FieldInput, HelperText } from './index.style';

export interface TextFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  helperText?: string;
  error?: string;
  fullWidth?: boolean;
  fieldSize?: 'sm' | 'md';
}

const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>(
  (
    {
      label,
      helperText,
      error,
      fullWidth = true,
      fieldSize = 'md',
      id,
      name,
      ...props
    },
    ref
  ) => {
    const fieldId = id || name;
    const helperId = fieldId ? `${fieldId}-helper` : undefined;
    const showHelper = Boolean(error || helperText);
    const describedBy = showHelper ? helperId : undefined;

    return (
      <FieldWrapper $fullWidth={fullWidth}>
        <FieldLabel htmlFor={fieldId}>{label}</FieldLabel>
        <FieldInput
          ref={ref}
          id={fieldId}
          name={name}
          aria-invalid={!!error}
          aria-describedby={describedBy}
          $hasError={!!error}
          $fullWidth={fullWidth}
          $size={fieldSize}
          {...props}
        />
        {showHelper && (
          <HelperText id={helperId} $hasError={!!error}>
            {error || helperText}
          </HelperText>
        )}
      </FieldWrapper>
    );
  }
);

TextField.displayName = 'TextField';

export default TextField;
